export default __webpack_public_path__ + "static/media/MARKETING_PR_EVENT.197ad61b.jpg";